const { TaskStates } = require('@sigmasms/shared-types/enums')
const { upgradeArray } = require('../utils')
const enumToConstant = require('../utils/enumToConstant')

const TASK_TYPES = upgradeArray([ 'sendings:bulk', 'payments:recurrent', 'billings:operations' ])
const TASK_STATES = enumToConstant(TaskStates)
const TASK_FREQUENCY = upgradeArray([ 'once', 'daily', 'weekly', 'monthly' ])

module.exports = {
  TASK_TYPES,
  TASK_STATES,
  TASK_FREQUENCY
}
